import {
  customElement
} from "./chunk.QAGUCU4C.js";
import {
  r
} from "./chunk.NBIYIO67.js";
import {
  n
} from "./chunk.QXWAL3TN.js";
import {
  __decorateClass
} from "./chunk.2QRLEY22.js";

// src/components/jb-i18n-data/jb-i18n-data.ts
var JbI18nData = class extends r {
  static find() {
    return document.querySelector("jb-i18n-data") || void 0;
  }
  getI18nDataCountriesForRegion(region) {
    return this.i18nData?.regions.find((obj) => obj.regionUid.toString() === region.toString())?.countries;
  }
  getI18nDataLanguageOptionsForCountry(country) {
    const languageOptions = [];
    this.i18nData?.regions.some((regionData) => {
      const foundData = regionData.countries.find(
        (obj) => obj.countryIsoCode.toString() === country.toString()
      )?.languageOptions;
      if (foundData) {
        foundData.forEach((languageOption) => {
          languageOptions.push(languageOption);
        });
        return null;
      }
      return null;
    });
    return languageOptions;
  }
  getI18nDataRegions() {
    return this.i18nData?.regions;
  }
  getLanguageByIsoCode(isoCode) {
    return this.i18nData?.globalLanguages[isoCode];
  }
  render() {
    return "";
  }
};
__decorateClass([
  n({ type: Object })
], JbI18nData.prototype, "i18nData", 2);
JbI18nData = __decorateClass([
  customElement("jb-i18n-data")
], JbI18nData);

export {
  JbI18nData
};
